export const terminalParametersTheme = {
  item: {
    borderColor: 'palette.tertiary.40',
    borderWidth: '1px',
    keyValue: 'palette.tertiary.95',
    name: 'palette.tertiary.95',
  },
};
